<template>
  <div class="search-input">
    <ElForm :model="formData" :rules="rulesForm" inline>
      <ElFormItem label=" " class="address-item">
        <AreaPicker @confirm="onPositionConfirm" ref="areaPicker" />
      </ElFormItem>
      <ElFormItem prop="search" label=" ">
        <ElInput class="input" v-model="formData.search" placeholder="请输入职位名称进行搜索" clearable />
      </ElFormItem>
      <ElFormItem label=" ">
        <ElButton type='primary' class="btn search-btn" @click="onSearch">搜索</ElButton>
        <ElButton class="btn reset-btn" @click="onReset">重置</ElButton>
      </ElFormItem>
    </ElForm>
  </div>
</template>

<script setup lang="ts">
import AreaPicker from "./area-picker/area-picker.vue";
import { ElInput, ElButton, ElForm, ElFormItem } from "element-plus"
import { ref, defineEmits } from "vue"

const areaPicker = ref();
const emit = defineEmits(['search', 'reset'])
// 搜索框校验
const validateSearchPass = (rule, value, callback) => {
  if (value && value.length === 1) {
    callback(new Error('至少输入两个字进行搜索'));
  }
  callback()
}
const formData = ref({
  city: '',
  search: ''
})
const rulesForm = ref({
  search: [
    { validator: validateSearchPass, trigger: ['blur', 'change'] }
  ]
})

const onPositionConfirm = (val) => {
  formData.value.city = val
}

const onSearch = () => {
  console.log('search', formData.value)
  emit('search', formData.value)
}

const onReset = () => {
  formData.value.search = ''
  formData.value.city = '全国'
  console.log(areaPicker.value.reset())
  emit('reset')
}
</script>

<style>
.search-input {
  width: 100%;
  margin-top: 4px;
}
.search-input .el-form--inline .el-form-item {
  margin-right: 0;
}
.search-input .address-item .el-form-item__label {
  padding-left: 0;
}
.btn {
  width: 76px;
  margin: 0;
}
.search-btn {
  background-color: #7E51E4;
  border-color: #7E51E4;
  color: #fff;
  &:hover {
   background-color: #9B6FFF;
   border-color: #9B6FFF;
  }
}
.reset-btn {
  background-color: #fff;
  border-color: #D9D9D9;
  color: #03050D;
  margin-left: 10px;
  &:hover {
    background-color: #fff;
    color: #9B6FFF;
    border-color: #9B6FFF;
  }
}
.input {
  width: 800px;
}

.el-input__wrapper.is-focus {
  box-shadow: 0 0 0  1px#7970FE;
}
</style>